var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMarkerRedesign = function SvgMarkerRedesign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.519 31.2C7.256 27.188 0 17.462 0 12 0 5.372 5.372 0 12 0c6.625 0 12 5.372 12 12 0 5.462-7.313 15.188-10.519 19.2a1.888 1.888 0 0 1-2.962 0ZM12 16c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4 1.794 4 4 4Z",
    fill: "#F0AC00"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.5,
    fill: "#EFEEEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v32H0z"
  })))));
};
export { SvgMarkerRedesign as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyNCAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzU5OF8zNjYyNCkiPgo8cGF0aCBkPSJNMTAuNTE4OCAzMS4yQzcuMjU2MjUgMjcuMTg3NSAwIDE3LjQ2MjUgMCAxMkMwIDUuMzcyNSA1LjM3MjUgMCAxMiAwQzE4LjYyNSAwIDI0IDUuMzcyNSAyNCAxMkMyNCAxNy40NjI1IDE2LjY4NzUgMjcuMTg3NSAxMy40ODEyIDMxLjJDMTIuNzEyNSAzMi4xNTYyIDExLjI4NzUgMzIuMTU2MiAxMC41MTg4IDMxLjJaTTEyIDE2QzE0LjIwNjMgMTYgMTYgMTQuMjA2MyAxNiAxMkMxNiA5Ljc5Mzc1IDE0LjIwNjMgOCAxMiA4QzkuNzkzNzUgOCA4IDkuNzkzNzUgOCAxMkM4IDE0LjIwNjMgOS43OTM3NSAxNiAxMiAxNloiIGZpbGw9IiNGMEFDMDAiLz4KPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iNC41IiBmaWxsPSIjRUZFRUVFIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNTk4XzM2NjI0Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjMyIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";